import { render, staticRenderFns } from "./new.vue?vue&type=template&id=05f74654&scoped=true&lang=html&"
import script from "./new.vue?vue&type=script&lang=js&"
export * from "./new.vue?vue&type=script&lang=js&"
import style0 from "./new.vue?vue&type=style&index=0&id=05f74654&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f74654",
  null
  
)

component.options.__file = "new.vue"
export default component.exports